import { ArrowBackIos, ArrowForwardIos } from '@mui/icons-material';
import { Box, IconButton } from '@mui/material';
import { useState } from 'react';
import useIsMobile from './hooks/useIsMobile';
import PageDocument from './PageDocument';

interface FrameProps {
    frameImage: string;
    contents: string[];
    isPdf?: boolean;
    isYoutube?: boolean;
}


function HorizontalFrame(props: FrameProps) {
    const [contentIndex, setContentIndex] = useState(0);
    const isMobile = useIsMobile();

    return (
        <Box
            sx={{
                position: 'relative',
                width: '100%',
                marginTop: '32px',
                overflow: 'hidden',
                display: 'flex',
                justifyContent: 'center',
            }}
        >
            {props.isPdf !== true && props.contents.length > 1 &&
                <>
                    <Box
                        sx={{
                            position: 'absolute',
                            top: { xs: '40%', md: '45%' },
                            left: '12%',
                            height: 'fit-content',
                            cursor: 'pointer',
                            zIndex: 5,
                        }}
                    >
                        <IconButton
                            onClick={() => {
                                contentIndex - 1 < 0 ? setContentIndex(props.contents.length - 1) : setContentIndex(contentIndex - 1);
                            }}
                            sx={{
                                filter: 'brightness(1.4)',
                                transition: 'filter 0.5s',
                                '&:hover': {
                                    filter: 'brightness(1.8)',
                                },
                            }}
                        >
                            <ArrowBackIos
                                color="secondary"
                                sx={{
                                    filter: 'drop-shadow(0 0 8px #000)',
                                }}
                            />
                        </IconButton>
                    </Box>
                    <Box
                        sx={{
                            position: 'absolute',
                            top: { xs: '40%', md: '45%' },
                            right: '12%',
                            height: 'fit-content',
                            cursor: 'pointer',
                            zIndex: 5,
                        }}
                    >
                        <IconButton
                            onClick={() => {
                                contentIndex + 1 >= props.contents.length ? setContentIndex(0) : setContentIndex(contentIndex + 1);
                            }}
                            sx={{
                                filter: 'brightness(1.4)',
                                transition: 'filter 0.5s',
                                '&:hover': {
                                    filter: 'brightness(1.8)',
                                },
                            }}
                        >
                            <ArrowForwardIos
                                color="secondary"
                                sx={{
                                    filter: 'drop-shadow(0 0 8px #000)',
                                }}
                            />
                        </IconButton>
                    </Box>
                </>
            }
            <img
                src={props.frameImage}
                alt="Frame"
                style={{
                    width: '100%',
                    height: 'auto',
                    filter: 'brightness(1.5)',
                }}
            />
            {props.isYoutube === true &&
                <iframe
                    src={props.contents[contentIndex]}
                    frameBorder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                    referrerPolicy="strict-origin-when-cross-origin"
                    allowFullScreen
                    title="YouTube Video"
                    style={{
                        border: 'none',
                        position: 'absolute',
                        top: '50%',
                        left: '50%',
                        width: '78%',
                        height: '68%',
                        transform: 'translate(-50%, -50%)',
                    }}
                />
            }
            {props.isPdf === true
                && <PageDocument
                    file={props.contents[contentIndex]}
                    height={isMobile ? 330 : 730}
                    pages={1}
                />
            }
            {props.isPdf !== true && props.isYoutube !== true &&
                <Box
                    component="img"
                    src={props.contents[contentIndex]}
                    alt="Inner Content"
                    sx={{
                        position: 'absolute',
                        top: '50%',
                        left: '50%',
                        width: '78%',
                        height: '68%',
                        transform: 'translate(-50%, -50%)',
                    }}
                />
            }
        </Box>
    );
}

export default HorizontalFrame;
